import { Modal, Form, Input, Image, Flex, Button, Radio, Select } from "antd";
import React, { useMemo, useState } from "react";
import UploadImage from "../../components/Elements/UploadImage";
import paymentMethodApi from "../../api/paymentMethod";
import IntlMessage from "../../components/IntlMessage";
import { useWatch } from "antd/es/form/Form";
import { payment_method } from "../../utils/constant";

const PaymentMethodForm = (props) => {
  const { isModalOpen, setIsModalOpen, currentData, onModalClose, onRefresh } =
    props;
  const [imageUrl, setImageUrl] = useState("");

  const initialValues = {
    ...currentData,
    status: currentData && currentData.status ? 1 : 0,
    title: currentData && currentData.title ? currentData.title : "",
    dipslay: currentData && currentData.dipslay ? currentData.dipslay : "",
    image: currentData && currentData.image ? currentData.image : "",
    method: currentData && currentData.method ? currentData.method : "",
    gateway_url:
      currentData && currentData.gateway_url ? currentData.gateway_url : "",
  };

  const onFinish = (values) => {
    console.log("Success:", values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };

  const [form] = Form.useForm();

  const fileList = useMemo(
    () =>
      currentData && currentData.image
        ? [
            {
              uid: "1",
              name: "image.png",
              status: "done ",
              url: currentData?.image,
            },
          ]
        : [],
    [currentData]
  );

  const onChangeImage = (_, file) => {
    setImageUrl(file);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then(async (values) => {
        const formData = new FormData();
        const data = { ...values };
        Object.keys(data).forEach((key) => {
          formData.append(key, data[key]);
        });
        if (imageUrl) {
          formData.append("image", imageUrl);
        }
        if (currentData) {
          await paymentMethodApi.update(currentData.id, formData);
          setIsModalOpen(false);
          onRefresh();
        } else {
          await paymentMethodApi.create(formData);
          setIsModalOpen(false);
          onRefresh();
        }
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const onChangePaymentMethod = (e) => {};

  return (
    <React.Fragment>
      <Modal
        title={
          currentData ? (
            <IntlMessage id="global.edit" />
          ) : (
            <IntlMessage id="global.add" />
          )
        }
        open={isModalOpen}
        onCancel={onModalClose}
        width={"50%"}
        footer={[
          <>
            <Button key="back" type="default" onClick={onModalClose}>
              {<IntlMessage id="global.cancel" />}
            </Button>
            <Button key="back" type="primary" onClick={handleOk}>
              {<IntlMessage id="global.save" />}
            </Button>
          </>,
        ]}
      >
        <Form
          name="basic"
          labelAlign="left"
          {...layout}
          className="ml-20"
          initialValues={initialValues}
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item label="Title" name="title" required>
            <Input placeholder="Input Title" />
          </Form.Item>

          <Form.Item label="Method" name="method">
            <Select
              showSearch
              placeholder="Select a customer"
              onChange={onChangePaymentMethod}
              filterOption={false}
              options={payment_method.map((item, i) => {
                return {
                  label: item.toLocaleUpperCase(),
                  value: item,
                };
              })}
            />
          </Form.Item>

          <Form.Item
            label="Display"
            name="display"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Gateway"
            name="gateway_url"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <Input />
          </Form.Item>

          {currentData ? (
            <Form.Item
              label="Status"
              name="status"
              rules={[
                {
                  required: true,
                  message: <IntlMessage id="global.requiredfield" />,
                },
              ]}
            >
              <Radio.Group name="radiogroup">
                <Radio value={1}>
                  <IntlMessage id="global.active" />
                </Radio>
                <Radio value={0}>
                  <IntlMessage id="global.inactive" />
                </Radio>
              </Radio.Group>
            </Form.Item>
          ) : null}

          <Form.Item label="Image" name="image">
            <Flex gap={4}>
              <UploadImage onChangeData={onChangeImage} initList={fileList} />
            </Flex>
          </Form.Item>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default PaymentMethodForm;
